import { render, staticRenderFns } from "./accept-call-icon.vue?vue&type=template&id=3b115068"
import script from "./accept-call-icon.vue?vue&type=script&lang=js"
export * from "./accept-call-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b115068')) {
      api.createRecord('3b115068', component.options)
    } else {
      api.reload('3b115068', component.options)
    }
    module.hot.accept("./accept-call-icon.vue?vue&type=template&id=3b115068", function () {
      api.rerender('3b115068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/accept-call-icon.vue"
export default component.exports